import {NgModule} from '@angular/core';
import {ConfirmModalComponent} from './confirm-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ButtonModule} from '@ucx/ui-cmp';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        ConfirmModalComponent,
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatTooltipModule,
        ButtonModule,
        CommonModule
    ],
    providers: [],
    exports: [
        ConfirmModalComponent
    ]
})

export class ConfirmModalModule {
}
